import React from 'react';
import { Agent } from '@/services/types/user';
import AgentCard from '../AgentCard/AgentCard';
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner';

interface AgentGridProps {
  agents: Agent[];
  isLoading?: boolean;
  error?: string | null;
  emptyMessage?: string;
}

const AgentGrid: React.FC<AgentGridProps> = ({
  agents,
  isLoading = false,
  error = null,
  emptyMessage = 'No agents found.',
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="lg" color="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 max-w-md mx-auto">
          <p className="font-medium">Error loading agents</p>
          <p className="text-sm mt-1">{error}</p>
        </div>
      </div>
    );
  }

  if (!agents || agents.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="bg-gray-50 border border-gray-200 text-gray-600 px-4 py-3 max-w-md mx-auto">
          <p className="font-medium">{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {agents.map((agent) => (
        <AgentCard key={agent.id} agent={agent} />
      ))}
    </div>
  );
};

export default AgentGrid;

